import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { getFetcher } from '../../../api/fetchers';
import { endpoints } from '../../../api/endpoints';
import { toast } from 'react-toastify';
import Spinner from '../../components/spinner/Spinner';
import { IoMdArrowRoundBack } from "react-icons/io";
import { parseStatics } from '../../function/parseStatics';


interface IPromotion {
    firstText: string,
    fourthText: string,
    id: string,
    images: any,
    secondText: string,
    status: boolean,
    supplierId: string,
    thirdText: string,
    title: string,
    updatedAt: string,
    videoLink: string
}

const AcademyProductDetail: React.FC = () => {
    const { id } = useParams();
    const [imageModal, setImageModal] = useState(false);
    const [promotion, setPromotion] = useState<IPromotion>();
    const [parsedImages, setParsedImages] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedImage, setselectedImage] = useState<string>();

    // GET PROMOTION BY SUPPLIERID
    useEffect(() => {
        const getPromotion = async () => {
            setLoading(true);
            try {
                const response = await getFetcher(endpoints.eAcademy.getPromotionByPromotionId.replace('{promotionId}', id || ''));
                if (response.result) {
                    setPromotion(response.promotion);
                    setParsedImages(parseStatics(response?.promotion?.images));
                    setTimeout(() => {
                        setLoading(false)
                    }, 500);
                } else {
                    toast.error('Error');
                }
            } catch (error) {
                console.log(error);
            }
        };
        getPromotion();
    }, [id]);

    const handleClickImage = (imgSrc: string) => {
        setImageModal(true)
        setselectedImage(imgSrc)
    }

    if(loading) {
        return <div className=' w-screen h-full'><Spinner /></div>
    }

    return (
        <div className="p-6 bg-gray-100 min-h-screen flex flex-col items-center w-full rounded-xl relative gap-y-10">
            {/* PRODUCT PROMOTION */}
            <div className="bg-white p-6 rounded-lg shadow-lg w-full ">
                <div className="text-center mb-6">
                    <h3 className="font-bold text-3xl text-primary-color">ECZA AKADEMİ</h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative">
                    <div className="flex-1 p-4 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                        <img
                            onClick={() => handleClickImage(parsedImages[0])}
                            className="rounded-lg w-full h-[300px]  cursor-pointer object-contain"
                            src={parsedImages && parsedImages[0]}
                            alt="Promotion Image 1"
                        />
                    </div>
                    <div className="flex-1 p-4 bg-gray-50 rounded-lg shadow-inner overflow-y-auto h-[400px]">
                            <h2 className=' text-xl tracking-wide font-bold text-primary-color'>Ürün Tanıtımı</h2>
                        <p className="text-gray-700 ">{promotion?.firstText}</p>
                        {/* <div className=' absolute -top-3 right-0 min-w-full sm:min-w-40 lg:min-w-60 xl:min-w-96 bg-primary-color text-white font-bold flex justify-center items-center rounded' >
                        </div> */}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 relative">
                    <div className="flex-1 p-4 bg-gray-50 rounded-lg shadow-inner overflow-y-auto h-[400px]">
                            <h2 className=' text-xl tracking-wide font-bold text-primary-color'>Kullanım Şekli</h2>
                        <p className="text-gray-700">{promotion?.secondText}</p>
                        {/* <div className=' absolute -top-3 left-0 min-w-full sm:min-w-40 lg:min-w-60 xl:min-w-96 bg-primary-color text-white font-bold flex justify-center items-center rounded' >
                        </div> */}
                    </div>
                    <div className="flex-1 p-4 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                        <img
                            onClick={() => handleClickImage(parsedImages[1])}
                            className="rounded-lg w-full h-[300px] object-contain cursor-pointer"
                            src={parsedImages && parsedImages[1]}
                            alt="Promotion Image 2"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 relative">
                    <div className="flex-1 p-4 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                        <iframe
                            className="rounded-lg w-full h-[400px] object-contain"
                            src={`https://www.youtube.com/embed/${promotion?.videoLink.split('=')[1]}`}
                            title="Video Title"
                            allowFullScreen
                        ></iframe>
                    </div>
                    <div className="flex-1 p-4 bg-gray-50 rounded-lg shadow-inner overflow-y-auto h-[400px]">
                            <h2 className=' text-xl tracking-wide font-bold text-primary-color'>Ürün Özellikleri</h2>
                        <p className="text-gray-700">{promotion?.thirdText}</p>
                        {/* <div className=' absolute -top-3 right-0 min-w-full sm:min-w-40 lg:min-w-60 xl:min-w-96 bg-primary-color text-white font-bold flex justify-center items-center rounded' >
                        </div> */}
                    </div>
                </div>

                <div className="mt-6 p-4 bg-gray-50 rounded-lg shadow-inner">
                    <h2 className=' text-xl tracking-wide font-bold text-primary-color'>Genel Bilgiler</h2>
                    <p className="text-gray-700">{promotion?.fourthText}</p>
                    {/* <div className=' absolute -top-3 left-0 min-w-full sm:min-w-40 lg:min-w-60 xl:min-w-96 bg-primary-color text-white font-bold flex justify-center items-center rounded' >
                        </div> */}
                </div>
            </div>

            <div className=' absolute top-0 left-5'>
                <Link to={'/academy/academy/product'} className=' flex justify-center items-center text-primary-color hover:underline'>
                    <IoMdArrowRoundBack size={20}/>
                    <p>geri dön</p>
                </Link>
                
            </div>

            {/* IMAGE MODAL */}
            {imageModal && (
                <div onClick={() => setImageModal(false)} className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
                    <div className="w-full h-full absolute" onClick={() => setImageModal(false)}></div>

                    <div className="relative w-full max-w-3xl h-2/3" onClick={(e) => e.stopPropagation()}>
                        <img className="w-full h-full rounded-lg object-contain" src={selectedImage && selectedImage} alt="Full-size Image" />
                        {/* <div className="absolute top-2 right-2">
                            <IoClose onClick={() => setImageModal(false)} className=" text-primary-color text-2xl cursor-pointer" />
                        </div> */}
                    </div>
                </div>
            )}
        </div>
    );
}

export default AcademyProductDetail;
